var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.topbar
  }, [_c('cui-breadcrumbs'), _vm.user.environment === 'development' ? _c('div', {
    staticClass: "ml-3 mr-3"
  }, [_c('a-tag', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("MEPX TEST OKRUŽENJE")])], 1) : _vm._e(), _c('div', {
    staticClass: "d-xl-block d-none mr-0 ml-auto"
  }, [_c('cui-user-menu')], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }